import menuList from "../constants/menuList";
import { useDispatch } from "react-redux";
import { setMenuItems } from "../store/slices/menuSlice";
import userTypes from "../constants/userTypes";

const useMenuLoader = () => {
    const dispatch = useDispatch();

    const hasPermission = (permissions, serviceName) => {
        // Eğer serviceName boş veya undefined ise, permission kontrolünü atla (her zaman görünür)
        if (!serviceName || serviceName === "") {
            return true;
        }
        return permissions?.some(
            (p) => p.ServiceName === serviceName && p.Operations.includes(2)
        );
    };

    const filterMenuItems = (items, permissions) => {
        return items
            .map((item) => {
                if (item.children && item.children.length > 0) {
                    const allowedChildren = item.children.filter((child) =>
                        hasPermission(permissions, child.serviceName)
                    );

                    if (
                        hasPermission(permissions, item.serviceName) ||
                        allowedChildren.length > 0
                    ) {
                        return {
                            text: item.text,
                            icon: item.icon,
                            children: allowedChildren.map((child) => ({
                                to: child.to,
                                text: child.text,
                                icon: child.icon,
                            })),
                        };
                    }

                    return null;
                } else {
                    if (hasPermission(permissions, item.serviceName)) {
                        return {
                            to: item.to,
                            text: item.text,
                            icon: item.icon,
                        };
                    }

                    return null;
                }
            })
            .filter(Boolean);
    };

    const getMenu = (permissions, type) => {
        let filteredMenu = [];

        switch (type) {
            case userTypes.EMPLOYEE:
                filteredMenu = filterMenuItems(menuList.employee, permissions);
                break;
            case userTypes.DOCTOR:
                filteredMenu = filterMenuItems(menuList.doctor, permissions);
                break;
            case userTypes.PATIENT:
                filteredMenu = menuList.patient;
                break;
            case userTypes.ASSISTANT:
                // Assistant için permission kontrolü yapmadan tüm menü öğelerini göster
                filteredMenu = menuList.assistant;
                break;
            default:
                break;
        }

        dispatch(setMenuItems(filteredMenu));
    };

    return { getMenu };
};

export default useMenuLoader;
